import axios from 'axios';
import {objToFormData} from "../helpers";

export default class {
    static get uri() {
        return null;
    }

    static all(params = {}) {
        return axios.get(this.uri, {
            params
        });
    }

    static find(id, params = {}) {
        return axios.get(`${this.uri}/${id}`, {
            params
        });
    }

    static create(params) {
        return axios.post(this.uri, objToFormData(params));
    }

    static update(id, params) {
        return axios.put(`${this.uri}/${id}`, params);
    }

    static delete(id) {
        return axios.delete(`${this.uri}/${id}`);
    }
}
